import { render, staticRenderFns } from "./BlogSectionArticlesStatic.vue?vue&type=template&id=48fa5d56&scoped=true&lang=pug&"
import script from "./BlogSectionArticlesStatic.vue?vue&type=script&lang=js&"
export * from "./BlogSectionArticlesStatic.vue?vue&type=script&lang=js&"
import style0 from "./BlogSectionArticlesStatic.vue?vue&type=style&index=0&id=48fa5d56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa5d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fa5d56')) {
      api.createRecord('48fa5d56', component.options)
    } else {
      api.reload('48fa5d56', component.options)
    }
    module.hot.accept("./BlogSectionArticlesStatic.vue?vue&type=template&id=48fa5d56&scoped=true&lang=pug&", function () {
      api.rerender('48fa5d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/BlogSectionArticlesStatic.vue"
export default component.exports